import * as React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

import {
  Container,
  Dropdown,
  Icon,
  Menu,
  Message,
  Segment,
} from "./semantic-ui";
import AccountWidget from "./AccountWidget";
import { homeUrl, creditsUrl, boardUrl, dashboardUrl } from "./urls";
import { withSession, SessionProps } from "./session";
import { ResponsiveMenu } from "./common";

import styles from "./PageLayout.module.css";

type Props = SessionProps & {
  children: React.ReactNode;
};

const PageLayout = ({
  me,
  sessionQuery: { loading, error },
  children,
}: Props) => {
  const rightContent = loading ? (
    <Menu.Item>
      <Icon loading name="spinner" />
    </Menu.Item>
  ) : error ? (
    <Dropdown item icon="exclamation triangle">
      <Dropdown.Menu>
        <Message error header="Error" content={error.toString()} />
      </Dropdown.Menu>
    </Dropdown>
  ) : (
    <AccountWidget me={me} />
  );
  return (
    <div className={styles.PageLayout}>
      <Helmet
        titleTemplate="%s | Chess 2 Online"
        defaultTitle="Chess 2 Online"
      />
      <ResponsiveMenu
        brand={
          <Menu.Item header as={Link} to={homeUrl}>
            Chess 2 Online
          </Menu.Item>
        }
        left={
          <>
            {me && (
              <Menu.Item as={Link} to={dashboardUrl}>
                Dashboard
              </Menu.Item>
            )}
            <Menu.Item as={Link} to={boardUrl()}>
              Local Game
            </Menu.Item>
          </>
        }
        right={rightContent}
      />
      <Container className={styles.mainContent}>{children}</Container>
      <Segment as="footer" attached inverted>
        <Container textAlign="center">
          Chess 2 Online was written by Ryan Patterson.{" "}
          <Link to={creditsUrl}>Site Credits</Link>
        </Container>
      </Segment>
    </div>
  );
};

export default withSession(PageLayout);
